export default __webpack_public_path__ + "static/harvard-easel-lab-logo-152261b451d54345d1d163bee4e21b73.png";